class RepeatingDaysController {
  constructor(Authentication, ShiftUtils) {
    'ngInject';

    this.Authentication = Authentication;
    this.ShiftUtils = ShiftUtils;
  }

  $onInit() {
    this.repeatingDays = [
      { key: 'MO', title: 'Mon', order: this._getOrder(1) },
      { key: 'TU', title: 'Tue', order: this._getOrder(2) },
      { key: 'WE', title: 'Wed', order: this._getOrder(3) },
      { key: 'TH', title: 'Thu', order: this._getOrder(4) },
      { key: 'FR', title: 'Fri', order: this._getOrder(5) },
      { key: 'SA', title: 'Sat', order: this._getOrder(6) },
      { key: 'SU', title: 'Sun', order: this._getOrder(0) },
    ];
  }

  get days() {
    return this.__days;
  }

  set days(value) {
    this.__days = value;
    this.daysObject = this.days
      ? this.days.split(',').reduce((reduced, day) => ((reduced[day] = true), reduced), {})
      : {};
  }

  clicked(row) {
    this.daysObject[row.key] = !this.daysObject[row.key];
    this.changedDays();
    this._setDirtyForm();
  }

  changedDays() {
    this.days = this.ShiftUtils.weekdays.filter((day) => this.daysObject[day]).join(',');
    this.form.$setValidity('OneDayIsRequired', Boolean(this.days));
  }

  _setDirtyForm() {
    if (this.form) {
      this.form.$setDirty();
    }
  }

  _getOrder(day) {
    if (day >= this.Authentication.user.orgSettings.firstDayOfWeek) {
      return 6 - (day - this.Authentication.user.orgSettings.firstDayOfWeek);
    }

    return this.Authentication.user.orgSettings.firstDayOfWeek - day - 1;
  }
}

export default {
  template: `
    <div class="btn-group select-recurrence-days">
      <button type="button" ng-repeat="row in ctrl.repeatingDays | orderBy:'-order'" ng-click="ctrl.clicked(row)" class="btn" ng-class="{'btn-default': !ctrl.daysObject[row.key], 'btn-primary': ctrl.daysObject[row.key]}">
        {{ row.title }}
      </button>
    </div>
  `,
  controller: RepeatingDaysController,
  controllerAs: 'ctrl',
  require: {
    form: '?^form',
  },
  bindings: {
    days: '=',
  },
};
